@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    padding: 0 3%;
}

.form {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1em;
    margin-top: 2em;
    margin-bottom: 2em;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: repeat(1, 1fr);
    }
}

.birthday {
    margin: 0;
}

.birthdayFields {
    display: flex;
    gap: 1em;

    div {
        flex-grow: 1;
    }
}

.dropdown {
    composes: defaultInput from "../../styles/composable/forms.module.css";
}

.labelText {
    padding: 0;
    text-transform: uppercase;
    white-space: nowrap;
}

.legalWrapper {
    border-bottom: 1px solid var(--color-silver);
    padding: 0 0 2rem;
    margin-bottom: 1rem;
}

.legalFieldWrapper {
    & a {
        color: black;
    }
}

.actions {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1em;
    grid-column: 1 / span 2;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-column: 1 / span 1;
    }
}

.send {
    composes: button from "../../styles/buttons.module.scss";
}
